module.exports = __webpack_public_path__ + "img/Heaving.cc63460f.gif";